module.exports = __webpack_public_path__ + "img/archive.7c214e3a.png";